<template>
  <div class="container-fluid">
    <Card>
      <template v-slot:header>
        <h4 class="d-inline">مـــرکــز آمــوزش</h4>
        <hr />
      </template>
      <template v-slot:content>
        <EducationTable :tablename="'Education'" :label="'موضوع آموزش'"></EducationTable>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import EducationTable from './Component/educationTable.vue'
export default {
  data() {
    return {}
  },
  components: { Card, EducationTable },
}
</script>
